import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const deleteNotificationService = id => {
  return privateRequest.delete(`${ConfEnv.API_URL.URL_NOTIFICATION}/${id}`);
};

export {deleteNotificationService};
